import React from 'react';

import * as ST from './styled';

interface ICard {
    title: string,
    description: string,
    icon: string,
}

const Cards = ({ title, description, icon }:ICard)=>{
    return (
        <ST.Card>
            <ST.Icon dangerouslySetInnerHTML={{ __html: '&#x' + icon + ';' }}/>
            <ST.Title>{title}</ST.Title>
            <ST.Description dangerouslySetInnerHTML={{ __html: description }}/>
        </ST.Card>
    );
};

export default Cards;
